export default {
  loading: {
    id: 'installment_simulation_loading',
    defaultMessage: 'Loading',
  },
}
